/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */


import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Checkbox, Button } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
    appBarSpacer: {
        ...theme.mixins.toolbar,
        [theme.breakpoints.down('xs')]: {
            minHeight: theme.spacing(10),
        }
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
        ...theme.custom.apiOverviewPage.tabs.credentials.styles
    },
    container: {
        paddingTop: theme.spacing(2.5),
        paddingBottom: theme.spacing(4),
        maxWidth: '1560px',
    },
    subTitle: {
        ...theme.custom.apiOverviewPage.tabs.credentials.subTitle
    },
    table: {
        minWidth: 500,
        width: '700px'
    },
    tableCellBorder: {
        ...theme.custom.apiOverviewPage.tabs.credentials.rowLabelText
    },
    td: {
        padding: '3px',
        borderWidth: 0,
    },
    iconButton: {
        padding: '0 0 0 10px',
        '& .material-icons': {
            fontSize: 16,
        },
    },
    leftCol: {
        width: 280,
    },
    margin: {
        marginRight: theme.spacing(2),
    },
    textFieldWeight: {
        fontWeight: 500
    },
    passwordCopyField: {
        maxWidth: '400px',
    },
    tableRow: {
        width: '65%',
    },
    buttonCell: {
        borderWidth: 0,
        paddingTop: '40px',
    },
    updateButton: {
        ...theme.custom.apiOverviewPage.tabs.credentials.updateButton,
        marginBottom: theme.spacing(2),
        height: theme.spacing(5)
    },
    generateButton: {
        ...theme.custom.apiOverviewPage.tabs.credentials.generateCredentialsButton,
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        height: theme.spacing(5)
    },
    loaderContainer: {
        width: "cal(100%-60px)",
        height: "70%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    componentPadding: {
        paddingLeft: theme.spacing(7),
        paddingRight: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        [theme.breakpoints.up('lg')]: {
            paddingLeft: 'auto',
            paddingRight: 'auto',
        }
    },
    outlineButtonCell: {
        padding: 0,
        borderWidth: 0,
        paddingTop: '10px'
    },
    grantTypeText: {
        ...theme.custom.apiOverviewPage.tabs.credentials.grantTypeTextStyle
    },
    generateBtn: {
        ...theme.custom.apiOverviewPage.tabs.credentials.generateAccessTokenButton
    },
    helperText: {
        ...theme.custom.apiOverviewPage.tabs.credentials.helperTextStyle
    },
    primaryTitleContainer: {
        paddingTop: theme.spacing(4),
    },
    primaryTitle: {
        ...theme.custom.appLandingPage.primaryTitleStyle
    },
    secondaryTitle: {
        ...theme.custom.appLandingPage.secondaryTitleStyle,
        marginBottom: theme.spacing(3.5)
    },
    imgContainer: {
        marginTop: theme.spacing(3),
    },
    image: {
        '@media (max-width: 1280px)': {
            width: "100%",
            height: "100%"
        }
    },
    createBtn: {
        marginLeft: theme.spacing(0),
        marginBottom: theme.spacing(1.5)
    },
    tabsBox: {
        borderBottom: `1px solid ${theme.palette.grey[200]}`,
      },
      tabs: {
        backgroundColor: theme.palette.primary.main,
      },
      tab: {
        minHeight: theme.spacing(7.5),
      },
      tabTextParent: {
        maxWidth: theme.spacing(16),
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      tabTitleText: {
        color: theme.custom.grey,
        fontSize: 13,
        fontWeight: 500,
        textTransform: 'initial',
      },
      markdownViewWrapper: {
        border: `1px solid ${theme.palette.grey[200]}`,
        width: '100%',
        height: '70vh',
        overflowY: 'auto',
      },
}));

export const CustomCheckbox = withStyles((theme) => ({
    root: {
        ...theme.custom.apiOverviewPage.tabs.credentials.grantTypeCheckBoxStyle
    },
    checked: {},
}))(Checkbox);

export const CustomButton = withStyles((theme) => ({
    root: {
        ...theme.custom.apiOverviewPage.tabs.credentials.removeCredentialsButton,
        left: theme.spacing(35),
        marginBottom: theme.spacing(2),
        fontSize: theme.spacing(1.5),
        height: theme.spacing(5)
    },
}))(Button);
